import styles from "../link-report.module.scss";

const format = Intl.NumberFormat(undefined, {
    style: "percent",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
}).format;

export function TotalPercentHeader({
    column: {
        columnDef: { accessorKey },
    },
    table: {
        options: {
            meta: { total },
        },
    },
}) {
    const value = total?.[accessorKey];
    return (
        <span className={styles.number}>
            {format(Number.isFinite(value) ? value : 0)}
        </span>
    );
}
